import React from 'react';

export const PrototypeRapidly = props => (
  <svg
    width="200"
    height="100"
    viewBox="0 0 200 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="65.3528"
      y="25.7894"
      width="40"
      height="40"
      transform="rotate(15 65.3528 25.7894)"
      fill="#444444"
    />
    <rect
      x="90.1744"
      y="22.9637"
      width="40"
      height="40"
      transform="rotate(30 90.1744 22.9637)"
      fill="#8F8F8F"
    />
    <rect
      x="117.495"
      y="22"
      width="40"
      height="40"
      transform="rotate(45 117.495 22)"
      fill="white"
    />
  </svg>
);
